module.exports = __webpack_public_path__ + "static/media/achievement-goen-walk-about.d0a53fd5.svg";